import { normalizeRideServices } from './driver-ride-services';

function displayPhone(driver) {
  const raw = driver?.phone || '';
  const digits = String(raw).replace(/\D/g, '');
  if (digits.length === 10) {
    return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
  }
  return raw || digits || '';
}

function normalizeApprovedDriver(row) {
  const fromApp = row.signup_source === 'app' || Boolean(row.app_profile_id);
  const hiringId = String(row.id);
  const profileId = fromApp ? String(row.app_profile_id || row.id) : hiringId;
  const base = {
    id: fromApp ? profileId : hiringId,
    hiring_id: hiringId,
    full_name: row.full_name || row.name || 'Driver',
    phone: row.phone || '',
    driver_photo_url: row.driver_photo_url || row.photo_url || null,
    vehicle_number: row.vehicle_number || null,
    vehicle_name: row.vehicle_name || null,
    vehicle_make: row.vehicle_make || null,
    vehicle_model: row.vehicle_model || null,
    vehicle_type: row.vehicle_type || row.vehicle_name || null,
    vehicles: row.vehicles,
    signup_source: row.signup_source || (fromApp ? 'app' : 'website'),
    ride_services: row.ride_services || null,
    origin: fromApp ? 'app' : 'web',
    app_profile_id: fromApp ? profileId : null,
  };
  return {
    ...base,
    ride_services: normalizeRideServices(base),
  };
}

export function assignableDriverLabel(driver) {
  const origin = driver.origin === 'app' ? ' · App' : ' · Website';
  const phone = displayPhone(driver) || '—';
  const trips =
    driver.ride_services === 'both'
      ? ' · Both'
      : driver.ride_services === 'daily'
        ? ' · Daily'
        : driver.ride_services === 'outstation'
          ? ' · Outstation'
          : '';
  return `${driver.full_name} · ${phone}${origin}${trips}`;
}

/** Only admin-approved drivers (website + app applications in public.drivers). */
export async function fetchAssignableDrivers(supabaseClient) {
  if (!supabaseClient) {
    return { drivers: [], error: 'Supabase is not configured.' };
  }

  const { data, error } = await supabaseClient
    .from('drivers')
    .select('*')
    .eq('status', 'approved')
    .order('name', { ascending: true, nullsFirst: false });

  if (error) {
    return {
      drivers: [],
      error: error.message || 'Could not load drivers.',
    };
  }

  const drivers = (data || []).map(normalizeApprovedDriver).sort((a, b) =>
    a.full_name.localeCompare(b.full_name, undefined, { sensitivity: 'base' })
  );

  return { drivers, error: '' };
}
